export const BYTES_IN_MB = 1024 * 1024;
export const MAX_FILE_SIZE_IN_MB = 200;
export const MAX_VIDEO_FILE_SIZE_IN_MB = 500;
export const MAX_AUDIO_FILE_SIZE_IN_MB = 50;
export const MAX_IMAGE_FILE_SIZE_IN_MB = 20;

export const ALLOWED_FILE_TYPES = [
  'image/*',
  '.pdf',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.mp4',
  '.mov',
  'video/quicktime',
  '.mp3',
  'audio/mpeg',
];
